export {clamp, snapValueToStep, toFixedNumber} from '../../../src/utils/number';
